<template>
	<div>
		<!-- logo 时间 -->
		<q-head></q-head>
		
		<div class="page-main">
			
		
			<div  class="read-bd-title fc" style="padding-left: 30px;"><i ></i><h3>{{radioIndex ? '项目查询' : '物价查询'}}</h3></div>	

			<div class="drug-list">
				<div class="drug-list-head">
					<div class="col1">
						
						{{radioIndex ? '项目名称' : '药品名称'}}
					</div>
					<div class="col2">
						单位
					</div>
					<div class="col3">
						价格
					</div>
				</div>
				<div class="drug-list-body">
					<div class="drug-list-item" v-for="(item,index) in 19">
						<div class="col1">
							{{index+1}}氯化钠注射液（09%）/250ml：2.25q/瓶
						</div>
						<div class="col2">
							瓶
						</div>
						<div class="col3">
							15.00
						</div>
					</div>
					
				</div>
			</div>
			
			<div class="drug-search-bar fc-bet">
				<div class="input">
					{{value || '点击弹出键盘，输入药品名称首字母搜索'}}
				</div>
				<button type="button" class="btn-so">
					<img src="../../assets/icon/icon-search.png" >
					<span>搜索</span>
				</button>
			</div>

			<div class="fc-bet p40" style="padding-right: 17px;">
				<div class="fcc">
					<div class="radio fcc" :class="{on:radioIndex == 0}" @click="changeRadio(0)">
						<img src="../../assets/icon/radio2.png" v-if="radioIndex<1">
						<img src="../../assets/icon/radio1.png" v-else>
						<span>查药品</span>
					</div>
					<div class="radio fcc"  :class="{on:radioIndex == 1}" @click="changeRadio(1)">
						<img src="../../assets/icon/radio2.png" v-if="radioIndex==1">
						<img src="../../assets/icon/radio1.png" v-else>
						<span>查项目</span>
					</div>
				</div>
				<div class="list-page fcc">
					<a>上一页</a>
					<span>第</span>
					<span>1/15</span>
					<span>页</span>
					<a>下一页</a>
				</div>
			</div>

			<div class="foot-buttons fc-bet">
				<a href="/" class="btn-home fcc">
					<img src="../../assets/icon/icon-home.png">
					<span>首页</span>
				</a>
				
				<a class="btn-return fcc" @click="returnStep()">
					<img src="../../assets/icon/icon-return.png">
					<span>返回</span>
				</a>
			</div>
		</div>
	</div>
</template>

<script>
	import qHead from '@/components/q-head/q-head.vue';
	
	
	export default {
		components: {
			qHead
			
		},
		data() {
			return {
				radioIndex:0,
				value:""
				
			}
		},
		mounted() {

		},
		methods: {
			changeRadio(i){
				this.radioIndex=i
			}
			
			
		},
		beforeDestroy() {
			//clearInterval(this.timer);
		}

	}
</script>

<style scoped lang="less">
	
</style>
